import React, { useState } from 'react';
import { Search, Clock, MapPin, Star, Calendar, Filter, MoreVertical, Phone, Flag, X } from 'lucide-react';

const RidesScreen = () => {
  const [activeTab, setActiveTab] = useState('active');
  const [openMenuId, setOpenMenuId] = useState(null);
// Modifică array-ul interventions în RidesScreen:

const [interventions] = useState([
  {
    id: 1,
    clientName: "Ioan Popescu",
    location: "Str. Principală 123, București",
    status: "active",
    startTime: "14:30",
    date: "19 Ian 2025",
    duration: "45 min",
    cost: "150 RON",
    problem: "Pană roată față dreapta",
    hasReview: false,
    phone: "0722123456"
  },
  {
    id: 2,
    clientName: "Maria Ionescu",
    location: "Bd. Magheru 24, București",
    status: "scheduled",
    startTime: "16:45",
    date: "19 Ian 2025",
    duration: "--",
    cost: "120 RON",
    problem: "Schimb anvelopă",
    hasReview: false,
    phone: "0723456789"
  },
  {
    id: 3,
    clientName: "George Popa",
    location: "Str. Decebal 55, București",
    status: "completed",
    startTime: "12:15",
    date: "19 Ian 2025",
    duration: "30 min",
    cost: "180 RON",
    problem: "Presiune scăzută",
    hasReview: false,
    phone: "0724567890"
  },
  {
    id: 4,
    clientName: "Ana Marin",
    location: "Calea Victoriei 10, București",
    status: "completed",
    startTime: "11:00",
    date: "18 Ian 2025",
    duration: "35 min",
    cost: "160 RON",
    problem: "Pană roată spate stânga",
    hasReview: true,
    rating: 5,
    phone: "0725678901"
  },
  {
    id: 5,
    clientName: "Mihai Dumitrescu",
    location: "Șos. Colentina 25, București",
    status: "scheduled",
    startTime: "18:30",
    date: "19 Ian 2025",
    duration: "--",
    cost: "140 RON",
    problem: "Verificare și umflare roți",
    hasReview: false,
    phone: "0726789012"
  }
]);

  const handleMenuClick = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const ActionMenu = ({ intervention }) => (
    <div className="relative">
      <button 
        onClick={(e) => {
          e.stopPropagation();
          handleMenuClick(intervention.id);
        }}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <MoreVertical className="w-5 h-5 text-gray-600" />
      </button>

      {openMenuId === intervention.id && (
        <>
          {/* Overlay to close menu when clicking outside */}
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setOpenMenuId(null)}
          />
          
          {/* Menu */}
          <div className="absolute right-0 bottom-full mb-2 w-48 bg-white rounded-xl shadow-lg border border-gray-200 py-1 z-20">
            <button 
              className="w-full px-4 py-2 text-left flex items-center text-gray-700 hover:bg-gray-50"
              onClick={() => window.open(`tel:${intervention.phone}`)}
            >
              <Phone className="w-4 h-4 mr-2" />
              <span>Sună clientul</span>
            </button>
            
            <button 
              className="w-full px-4 py-2 text-left flex items-center text-gray-700 hover:bg-gray-50"
              onClick={() => {/* Implementează raportare */}}
            >
              <Flag className="w-4 h-4 mr-2" />
              <span>Raportează problemă</span>
            </button>
            
            <button 
              className="w-full px-4 py-2 text-left flex items-center text-red-600 hover:bg-gray-50"
              onClick={() => {/* Implementează anulare */}}
            >
              <X className="w-4 h-4 mr-2" />
              <span>Anulează intervenția</span>
            </button>
          </div>
        </>
      )}
    </div>
  );

  const InterventionCard = ({ intervention }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-4">
      <div className="flex justify-between items-start mb-3">
        <div>
          <h3 className="font-semibold text-gray-800">{intervention.clientName}</h3>
          <div className="flex items-center text-gray-500 text-sm mt-1">
            <Calendar className="w-4 h-4 mr-1" />
            <span>{intervention.date}</span>
            <span className="mx-2">•</span>
            <Clock className="w-4 h-4 mr-1" />
            <span>{intervention.startTime}</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold text-blue-600">{intervention.cost}</span>
          <ActionMenu intervention={intervention} />
        </div>
      </div>

      <div className="mt-3">
        <div className="flex items-start">
          <MapPin className="w-4 h-4 text-gray-400 mt-1" />
          <div className="ml-2">
            <p className="text-gray-800">{intervention.location}</p>
          </div>
        </div>
        
        <div className="mt-2 flex items-center">
          <Clock className="w-4 h-4 text-gray-400 mr-2" />
          <span className="text-gray-600">Durată: {intervention.duration}</span>
        </div>

        <div className="mt-2">
          <p className="text-gray-600 text-sm">{intervention.problem}</p>
        </div>
      </div>

      <div className="mt-4 flex justify-between items-center">
        <div className="flex items-center">
          <div className={`px-3 py-1 rounded-full text-sm ${
            intervention.status === 'active' ? 'bg-green-100 text-green-700' :
            intervention.status === 'scheduled' ? 'bg-blue-100 text-blue-700' :
            'bg-gray-100 text-gray-700'
          }`}>
            {intervention.status === 'active' ? 'În desfășurare' :
             intervention.status === 'scheduled' ? 'Programată' :
             'Finalizată'}
          </div>
        </div>
        
        {intervention.status === 'completed' && (
          <button 
            className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            onClick={() => {/* Implementează review */}}
          >
            <Star className="w-4 h-4 mr-1" />
            <span>Lasă Review</span>
          </button>
        )}
      </div>
    </div>
  );

  // ... restul codului pentru header și listă

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="px-4 py-6">
          <h1 className="text-2xl font-bold text-gray-800">Istoricul Intervențiilor</h1>
          
          {/* Search and Filter */}
          <div className="mt-4 flex gap-2">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Caută intervenții..."
                className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button className="p-2 border border-gray-200 rounded-xl">
              <Filter className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          {/* Tabs */}
          <div className="flex gap-4 mt-6 overflow-x-auto pb-2">
            {['active', 'scheduled', 'completed'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  activeTab === tab
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {tab === 'active' ? 'În desfășurare' :
                 tab === 'scheduled' ? 'Programate' :
                 'Finalizate'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Interventions List */}
      <div className="p-4">
        <div className="space-y-4">
          {interventions
            .filter(intervention => intervention.status === activeTab)
            .map(intervention => (
              <InterventionCard key={intervention.id} intervention={intervention} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default RidesScreen;